// extracted by mini-css-extract-plugin
export var locationCard = "_ot-0";